enum BioType {
  FaceFront = 'FaceFront',
  FaceLeft45 = 'FaceLeft45',
  FaceLeft90 = 'FaceLeft90',
  FaceRight45 = 'FaceRight45',
  FaceRight90 = 'FaceRight90',
  FullBody = 'FullBody',

  SMT = 'SMT',

  LeftThumbFlat = 'LeftThumbFlat',
  LeftIndexFlat = 'LeftIndexFlat',
  LeftMiddleFlat = 'LeftMiddleFlat',
  LeftRingFlat = 'LeftRingFlat',
  LeftLittleFlat = 'LeftLittleFlat',
  RightThumbFlat = 'RightThumbFlat',
  RightIndexFlat = 'RightIndexFlat',
  RightMiddleFlat = 'RightMiddleFlat',
  RightRingFlat = 'RightRingFlat',
  RightLittleFlat = 'RightLittleFlat',
  LeftThumbRoll = 'LeftThumbRoll',
  LeftIndexRoll = 'LeftIndexRoll',
  LeftMiddleRoll = 'LeftMiddleRoll',
  LeftRingRoll = 'LeftRingRoll',
  LeftLittleRoll = 'LeftLittleRoll',
  RightThumbRoll = 'RightThumbRoll',
  RightIndexRoll = 'RightIndexRoll',
  RightMiddleRoll = 'RightMiddleRoll',
  RightRingRoll = 'RightRingRoll',
  RightLittleRoll = 'RightLittleRoll',
  LeftFourSlap = 'LeftFourSlap',
  RightFourSlap = 'RightFourSlap',
  TwoThumbSlap = 'TwoThumbSlap',
  FBICard = 'FBICard',

  LeftFullPalm = 'LeftFullPalm',
  LeftHypothenar = 'LeftHypothenar',
  LeftLowerPalm = 'LeftLowerPalm',
  LeftUpperPalm = 'LeftUpperPalm',
  RightFullPalm = 'RightFullPalm',
  RightHypothenar = 'RightHypothenar',
  RightLowerPalm = 'RightLowerPalm',
  RightUpperPalm = 'RightUpperPalm',

  LeftIris = 'LeftIris',
  RightIris = 'RightIris'
}

export default BioType

export const faceCaptureBioTypes = [
  BioType.FaceFront,
  BioType.FaceLeft45,
  BioType.FaceLeft90,
  BioType.FaceRight45,
  BioType.FaceRight90,
  BioType.FullBody
]
export const SMTBioTypes = [BioType.SMT]
export const fingerprintBioTypes = [
  BioType.LeftThumbFlat,
  BioType.LeftIndexFlat,
  BioType.LeftMiddleFlat,
  BioType.LeftRingFlat,
  BioType.LeftLittleFlat,
  BioType.RightThumbFlat,
  BioType.RightIndexFlat,
  BioType.RightMiddleFlat,
  BioType.RightRingFlat,
  BioType.RightLittleFlat,
  BioType.LeftThumbRoll,
  BioType.LeftIndexRoll,
  BioType.LeftMiddleRoll,
  BioType.LeftRingRoll,
  BioType.LeftLittleRoll,
  BioType.RightThumbRoll,
  BioType.RightIndexRoll,
  BioType.RightMiddleRoll,
  BioType.RightRingRoll,
  BioType.RightLittleRoll,
  BioType.LeftFourSlap,
  BioType.RightFourSlap,
  BioType.TwoThumbSlap
]
export const palmBioTypes = [
  BioType.LeftFullPalm,
  BioType.LeftHypothenar,
  BioType.LeftLowerPalm,
  BioType.LeftUpperPalm,
  BioType.RightFullPalm,
  BioType.RightHypothenar,
  BioType.RightLowerPalm,
  BioType.RightUpperPalm
]
export const irisBioTypes = [BioType.LeftIris, BioType.RightIris]
